module.exports = __webpack_public_path__ + "images/areamap/btn_mappin_hokkaido-tohoku_sp_7226374a9908581a06d4135177abcaa3.png";